module.exports = __webpack_public_path__ + "img/team_maho.e1c70e9b.jpg";